module.exports = __webpack_public_path__ + "static/media/flapping_wings.d293f757.ogg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/sound/flapping_wings.ogg
// module id = 289
// module chunks = 0